import { createContainer } from 'react-sweet-state';
import { store } from '../main';
export var LoadedUiModificationsContainer = createContainer(store, {
  displayName: 'LoadedUiModificationsContainer',
  onInit: function onInit() {
    return function (_ref, _ref2) {
      var setState = _ref.setState;
      var viewType = _ref2.viewType;
      setState({
        viewType: viewType
      });
    };
  }
});